module.exports = __webpack_public_path__ + "28889c60642fd3d81b003fb3d308d2f1.svg";